import React from "react";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import Logo from "../assets/sbw 1.png";
import VersionBetaLogo from "../assets/VersionBetaLogo.svg";
import * as Yup from "yup";
import FormField from "../utility/FormField";
import background from "../assets/background.png";
import { forgotPassword } from "../store/reducers/forgotPassword";
import Button from "./Button";
import { toast } from "react-toastify";

const ForgotPassword = () => {
  const dispatch = useDispatch();

  const validationSchema = Yup.object().shape({
    sm_email: Yup.string()
      .email("Invalid email format")
      .required("email ID is required"),
  });

  return (
    <>
      <div
        className="min-h-screen"
        style={{
          backgroundImage: `url(${background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="grid grid-cols-12">
          <div className="col-span-8"></div>
          <div className="min-h-screen p-8 col-span-8 md:col-span-5 lg:col-span-4 xl:col-span-4 2xl:col-span-4 bg-[#0d223d]/60 backdrop-blur-[80px] shadow-[inset_5px_5px_4px_0px_rgba(255,255,255,0.10)] shadow-[inset_-5px_-5px_250px_0px_rgba(255,255,255,0.02)] inline-flex">
            <div className="w-full flex-col justify-center items-center inline-flex gap-6">
              <>
                <div className="relative inline-block mb-4">
                  <img
                    src={Logo}
                    className="w-full sm:max-w-[140px] lg:max-w-[262px]"
                  />

                  <img
                    src={VersionBetaLogo}
                    className="absolute"
                    style={{
                      top: "20%",
                      right: "10%",
                      width: "15%"
                    }}
                  />
                </div>
              </>
              <div className="w-full border-t border-[#b3b5bd]"></div>
              <div className="w-full">
                <h6 className="text-center justify-center mb-6 text-[#F3F4F8] text-base font-normal font-['Poppins'] leading-[18px]">
                  Create a new password
                </h6>
                <Formik
                  initialValues={{
                    sm_email: "",
                  }}
                  validationSchema={validationSchema}
                  onSubmit={async (values, { setSubmitting }) => {
                    try {
                      const response = await dispatch(forgotPassword(values));
                      if (response?.payload?.status === "success") {
                        localStorage.setItem("email", values.sm_email);
                        toast.success(response?.payload?.message);
                      }
                    } catch (error) {
                      toast.error(error.response.data.message);
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting, isValid, dirty }) => (
                    <Form>
                      <FormField label="Email ID" name="sm_email" type="text" />
                      <div className="mt-8">
                        <Button
                          type="submit"
                          disabled={isSubmitting || !isValid || !dirty}
                          primary={isValid && dirty ? true : false}
                        >
                          Create password
                        </Button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
